/* eslint-disable no-param-reassign */
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '~/store/actions';
import api from '~/services';
import log from '~/helpers/log';

export default function useDeleteContact(values = false) {
  const [deleteContact, setDeleteContactValue] = useState(values);
  const dispatch = useDispatch();

  async function setDeleteContact(id, tab) {
    try {
      await api.contacts.delete.deleteContact(id);
      dispatch(actions.deleteContact(tab, id));
      setDeleteContactValue(true);
    } catch (err) {
      log.error('Failed to delete contact.', err);
    }
  }

  return [deleteContact, setDeleteContact];
}
